<!--
 * @Description:
 * @Date: 2019-09-26 16:13:52
 -->
<template>
  <div class="risk-box">
    <el-form
      :model="ruleForm"
      :disabled="isDialog"
      :rules="rules"
      ref="ruleForm"
      label-width="220px"
      class="ruleForm rmgt"
    >
      <!--todo 记得合并等级医院-->
      <div class="risk-tips">
        注：风控规则由平台保留最终解释权，所有风控内容最终以平台设置的可调范围为准。
      </div>
      <el-form-item label="任务最低间隔时间：" prop="intervalTime">
        <el-input
          disabled
          :value="ruleForm.intervalTime || range.intervalTime"
          placeholder=""
        >
          <span slot="suffix">分钟</span>
        </el-input>
        <span class="note-s1">
          注：当前任务结束时间与下个任务开始时间间隔（线下场景生效）
        </span>
      </el-form-item>
      <el-form-item label="任务定位距离：">
        <div class="distance" v-for="(item, index) in list" :key="index">
          <span>任务间隔</span>
          <el-input
            v-model="item.minuteTime"
            disabled
            placeholder=""
            style="margin:0 12px"
          >
            <span slot="suffix">分钟</span>
          </el-input>
          <span>内，用户移动距离不得超过</span>
          <el-input
            v-model="item.distanceKilometre"
            disabled
            placeholder=""
            style="margin:0 30px 0 12px"
          >
            <span slot="suffix">公里</span>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="执行者年龄区间：">
        <el-input
          disabled
          :value="ruleForm.ageStart || range.ageStart"
          placeholder=""
        >
          <span disabled slot="suffix">岁</span>
        </el-input>
        <span class="line"></span>
        <el-input
          disabled
          :value="ruleForm.ageEnd || range.ageEnd"
          placeholder=""
        >
          <span disabled slot="suffix">岁</span>
        </el-input>
      </el-form-item>
      <el-form-item
        label="单日最多拜访医生人次："
        prop="dayNumber"
        :rules="
          validVisitPeople(
            1,
            range.dayNumberIsUpdate ? range.theDoctors : ruleForm.dayNumber
          )
        "
      >
        <el-input
          :disabled="!range.dayNumberIsUpdate"
          v-model="ruleForm.dayNumber"
          @blur="fommatNumber('dayNumber')"
          placeholder=""
          v-if="!!isDialog || range.dayNumberIsUpdate"
        >
          <span slot="suffix">人</span>
        </el-input>
        <el-input
          :disabled="true"
          v-model="range.theDoctors"
          placeholder=""
          v-else
        >
          <span slot="suffix">人</span>
        </el-input>
        <span v-if="range.theDoctors" class="note-s1">
          可调范围：1 - {{ range.theDoctors }}人
        </span>
      </el-form-item>
      <el-form-item
        label="不可重复拜访相同医生："
        prop="dayDoctor"
        :rules="
          validVisitPeople2(
            range.dayDoctorIsUpdate ? range.dayDoctor : ruleForm.dayDoctor
          )
        "
      >
        <el-input
          :disabled="!range.dayDoctorIsUpdate"
          v-model="ruleForm.dayDoctor"
          @blur="fommatNumber('dayDoctor')"
          placeholder=""
          v-if="!!isDialog || range.dayDoctorIsUpdate"
        >
          <span slot="suffix">日内</span>
        </el-input>
        <el-input
          :disabled="true"
          v-model="range.dayDoctor"
          placeholder=""
          v-else
        >
          <span slot="suffix">日内</span>
        </el-input>
        <span v-if="+range.dayDoctor >= 0" class="note-s1">
          可调范围：大于等于{{ range.dayDoctor }}日
        </span>
      </el-form-item>
      <el-form-item
        label="拜访时间："
        prop="startTime"
        :rules="
          validVisitTime(
            range.startTime,
            range.endTime ? range.endTime : range.entTime,
            ruleForm.startTime,
            ruleForm.endTime,
            range.timeIsUpdate
          )
        "
      >
        <div class="form-item-flex">
          <el-time-picker
            value-format="HH:mm"
            :class="{ 'hidden-ss': ruleForm.startTime }"
            :disabled="!range.timeIsUpdate"
            v-model="ruleForm.startTime"
            :picker-options="timeSelectOptions"
            placeholder="选择时间"
            v-if="!!isDialog || range.timeIsUpdate"
          ></el-time-picker>
          <el-time-picker
            v-else
            value-format="HH:mm"
            :class="{ 'hidden-ss': ruleForm.startTime }"
            :disabled="true"
            v-model="range.startTime"
            :picker-options="timeSelectOptions"
            placeholder="选择时间"
          ></el-time-picker>
          <span class="line"></span>
          <el-time-picker
            value-format="HH:mm"
            :class="{ 'hidden-ss': ruleForm.endTime }"
            :disabled="!range.timeIsUpdate"
            v-model="ruleForm.endTime"
            :picker-options="timeSelectOptions"
            placeholder="选择时间"
            v-if="!!isDialog || range.timeIsUpdate"
          ></el-time-picker>
          <el-time-picker
            v-else
            value-format="HH:mm"
            :class="{ 'hidden-ss': ruleForm.endTime }"
            :disabled="true"
            v-model="range.endTime"
            :picker-options="timeSelectOptions"
            placeholder="选择时间"
          ></el-time-picker>
          <span class="note-s1" v-if="range.startTime && !isDialog">
            可调范围：{{ range.startTime }}-{{
              range.endTime ? range.endTime : range.entTime
            }}
          </span>
        </div>
      </el-form-item>
      <template v-if="!isDialog">
        <el-form-item>
          <span style="color:#9D9D9D">注：所有修改内容将于次日0:00生效</span>
        </el-form-item>
        <div style="display: flex;justify-content: center">
          <el-button type="primary" class="bts" @click="save">保存</el-button>
          <el-button type="primary" class="bts" @click="record">
            风控记录
          </el-button>
        </div>
      </template>
    </el-form>
  </div>
</template>

<script>
import { makeSure } from '@/Mixin/makeSure';
import mixins from '../mixins/index';

export default {
  mixins: [makeSure, mixins],
  name: 'baseHospital',
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: function() {
        return {};
      }
    },

    listobj: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    fommatNumber(key) {
      this.ruleForm[key] = this.ruleForm[key].replace(/[^0-9]/g, '');
    }
  }
};
</script>
<style lang="scss">
.rmgt {
  .el-input__suffix {
    right: 12px;
    color: #000;
  }
}

.risk-box {
  .ruleForm .el-form-item .el-input {
    width: 160px;
  }
}
</style>
<style scoped lang="scss">
.ruleForm {
  padding: 0;
}

.risk-tips {
  color: #9d9d9d;
  font-size: 13px;
  margin-bottom: 40px;
}

.note-s1 {
  margin-left: 30px;
  color: #9d9d9d;
  font-size: 13px;
}

.distance {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.check {
  position: absolute;
  right: 30.68%;
}

.line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 12px;
  display: inline-block;
}
</style>
